/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreferenceReference
 */
export interface PreferenceReference {
    /**
     * 
     * @type {string}
     * @memberof PreferenceReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PreferenceReference
     */
    label: string;
}

/**
 * Check if a given object implements the PreferenceReference interface.
 */
export function instanceOfPreferenceReference(value: object): value is PreferenceReference {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PreferenceReferenceFromJSON(json: any): PreferenceReference {
    return PreferenceReferenceFromJSONTyped(json, false);
}

export function PreferenceReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferenceReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function PreferenceReferenceToJSON(value?: PreferenceReference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

